import { gql } from "@apollo/client";

export const OPERATIONS_QUERY = gql`
    query Operations($timePeriod: TimePeriod $highlightsTimePeriod: TimePeriod $salesFilters: SalesFilterInput) {
        stockAmountCases {
            items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
            }
        }
        stockAmountDollars (filter: $salesFilters) {
            items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
            }
        }
        inventoryTurnOverUnits (filter: $salesFilters) {
            items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
            }
        }
        perfectOrderRates (filter: $salesFilters) {
            items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
            }
        }
        onTimeDeliveryRates (filter: $salesFilters) {
            items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
            }
        }
        orderFillRates (filter: $salesFilters) {
            items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
            }
        }
        backOrderRates (filter: $salesFilters) {
            items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
            }
        }
        forecastAccuracy (filter: $salesFilters) {
            items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
            }
        }
        freightPercentOfRevenue (filter: $salesFilters) {
            items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
            }
        }



        backorderedSKUs(timePeriod: $highlightsTimePeriod, filter: $salesFilters) {
            items {
                lastPeriodNetSales
                name
                netSales
                percentage
                rank
                unitSold
            }
        }
        lowestOTIFCustomers(timePeriod: $highlightsTimePeriod, filter: $salesFilters) {
            items {
                lastPeriodNetSales
                name
                netSales
                percentage
                rank
                unitSold
            }
        }
        lowestOTIFFulfillmentWarehouses(timePeriod: $highlightsTimePeriod, filter: $salesFilters) {
            items {
                lastPeriodNetSales
                name
                netSales
                percentage
                rank
                unitSold
            }
        }




        stockAmountBySubBrand(timePeriod: $timePeriod, filter: $salesFilters) {
            items {
                lastPeriodNetSales
                name
                netSales
                percentage
                rank
                unitSold
            }
        }
        stockAmountByRegion(timePeriod: $timePeriod, filter: $salesFilters) {
            items {
                lastPeriodNetSales
                name
                netSales
                percentage
                rank
                unitSold
            }
        }
        otifFailsByWarehouses (filter: $salesFilters) {
            items {
                percentage
                rank
                value
                warehouseName
            }
        }
        otifFailsCustomers (filter: $salesFilters) {
            items {
                customerName
                percentage
                rank
                value
            }
        }
        otifOverTimes (filter: $salesFilters) {
            items {
                month
                onTimeDelivery
                orderFillRate
                perfectOrderRate
            }
        }
        otifFailsByWarehouseMonthlies (filter: $salesFilters) {
            items {
                month
                values {
                    failCaseCount
                    warehouseName
                }
            }
        }
        casesInStockVsOrderedMonthlies (filter: $salesFilters) {
            items {
                casesSoldCurrentMonth
                casesSoldCurrentQuarter
                casesSoldCurrentYear
                forecastCurrentMonth
                forecastCurrentQuarter
                forecastCurrentYear
                month
                monthNumber
                stockCurrentMonth
                stockCurrentQuarter
                stockCurrentYear
                year
            }
        }
        casesOrderedVsForecastedSubBrandMonthlies (filter: $salesFilters) {
            items {
                month
                values {
                    casesOrdered
                    forecastedCases
                    subBrandName
                }
            }
        }
        top10BackorderedSKUs (filter: $salesFilters) {
            items {
                rank
                skuName
                value
            }
        }
        top10StockedSKUs (filter: $salesFilters) {
            items {
                rank
                skuName
                value
            }
        }






    }

`;

